/**
 *  24/06/2025 v 1.0 - JuanMa
 * */

import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import ClienteRestful from "../network/ClienteRestful";
import SelectorLista from "./SelectorLista";
import {filtrarConNombreCampo, filtrarConNombreCampoElemento} from "../utils/FilterUtils"
import {getFiltroFromCampo, getFiltroInicialFromCampoFECHAPERIODO, getFiltroFromCondicion} from "../utils/FiltroGridUtils";
import { FILTRO_MAYOR } from './FormularioGridBusqueda'
import {objetoEsVacio} from "../utils/ObjectUtils";
import {nombrePaquete} from "../../../dental/Configuracion";
import {cacheClaseChanged} from "../../../dental/redux/cache/actions";
import connect from "react-redux/es/connect/connect";
import {Button, InputGroup, Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../adazzle/GridRDG";
import DialogoEsqueleto from "../../blueprint/DialogoEsqueleto";
import Pacientes from "../../../dental/general/Pacientes";


class SelectorClaseObjeto extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            titulo: props.titulo,
            campoValor: props.campoValor,
            campoMostrar: props.campoMostrar,
            valor: props.valor,
            valorInicial: props.valorInicial,
            clase: props.clase,

            elemento: props.elemento,
            formularioElementoOpened: false,
            //elementosSeleccionado: null,
        }
    }

    componentDidUpdate(prevProps, prevState) {
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};


        if (nextProps.elemento !== prevState.elemento) {
            newState.elemento = nextProps.elemento;
        }

        if (nextProps.camposValor !== prevState.camposValor) {
            newState.camposValor = nextProps.camposValor;
        }
        if (nextProps.campoMostrar !== prevState.campoMostrar) {
            newState.campoMostrar = nextProps.campoMostrar;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    abrirFormulario= () => {
        this.setState({formularioElementoOpened: true});
    }

    onAceptarFormulario= () => {
        const {elementoSeleccionado} = this.state;
        const {onElementoChanged} = this.props;
        console.log("XXXXXXXX SELECTORCLASEOBJETO - onAceptarFormulario");
        //console.log("elementoSeleccionado: ", elementoSeleccionado);
        //console.log("onElementoChanged: ". onElementoChanged);

        this.setState({formularioElementoOpened: false}, () => {
            onElementoChanged && onElementoChanged(elementoSeleccionado);
        });
    }

    onCancelarFormulario= () => {
        this.setState({formularioElementoOpened: false});
    }

    onElementoSeleccionado= (elemento) => {
        //console.log ("SELECTOR CLASE OBJETO - onElementoSeleccionado");
        //console.log("elemento: ", elemento);
        this.setState({elementoSeleccionado: elemento}, () => {this.onAceptarFormulario()});
    }

    render() {
        const {titulo, icon, elemento, elementoSeleccionado, campoMostrar, formularioElementoOpened} =  this.state;
        const {width, formulario} = this.props;

        console.log("SELECTOR CLASE OBJETO RENDER");
        //console.log("formulario: ", formulario);
        //console.log("elemento: ", elemento);
        ///console.log("elementoSeleccionado: ", elementoSeleccionado);

        let widthReal= width ? width.toString() + "px" : "400px";
        let valorMostrar= "";
        let valorCodigoid= "";
        if (elemento != undefined) {
            valorMostrar = elemento[campoMostrar] ? elemento[campoMostrar]  : "";
            valorCodigoid=  elemento.codigoid ? elemento.codigoid : "";
        }

        let valor= "(" + valorCodigoid + ") " + valorMostrar;


        //Creamos el nuevo componente Formulario con la funcion inyectada.
        let formularioConProps= null;
        if (formulario)
            formularioConProps = React.cloneElement(formulario, { onElementoSeleccionado: this.onElementoSeleccionado} );
        //console.log("formularioConProps: ", formularioConProps);

        return (
            <>
                <div className="selectorlista">
                    <InputGroup
                        readonly={true}
                        style={{width: widthReal}}
                        autoComplete="off"
                        leftIcon={icon ? icon : "filter-list"}
                        placeholder={titulo}
                        value={valor ? valor : ""}
                        onClick={this.abrirFormulario}
                    />

                    <Button icon="eye-open" className="selectorlista_boton" onClick={this.abrirFormulario}/>
                </div>
                <DialogoEsqueleto opened={formularioElementoOpened} titulo={titulo} width= {"90%"} height={"700px"}
                                  onAceptar={this.onAceptarFormulario} onCancelar={this.onCancelarFormulario} mostrarCancelar={true}>
                    {   (formularioConProps != null &&
                            formularioConProps)
                    }
                </DialogoEsqueleto>
            </>
        );
    }
}


SelectorClaseObjeto.propTypes = {

    campoValor: PropTypes.string.isRequired,
    campoMostrar: PropTypes.string.isRequired,
    valor: PropTypes.object,
    condiciones: PropTypes.array,
    obligatorio: PropTypes.bool,
    width: PropTypes.any,

    onElementoChanged: PropTypes.func,
    formulario: PropTypes.element.isRequired,
}

const mapStateToProps = function(state) {
    return {
        cache: state.cache,
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(SelectorClaseObjeto);

